<template>
  <div :class=bem()>
    <Swiper
      v-bind="intheboxSwiperOptions"
    >
      <SwiperSlide
        v-if="showDefaultInTheBoxProduct"
        :class="bem('slide')"
      >
        <div :class="bem('img-container')">
          <StaticThreeSixtyFrame
            v-if="show360"
            :customised-product="customisedProduct"
            :show-iris-preview="showIrisPreview"
            :frame-number="14"
            :width="400"
            :height="400"
            :class="bem('product-img')"
          />
          <DynamicImg
            v-else
            :view-angle="2"
            bg=""
            :sku="customisedProduct.legacySKU"
            :scale="1.1"
          />
        </div>

        <div :class="bem('card-content')">
          <h5 :class="bem('card-title')">SunGod {{ customisedProduct.productName }}</h5>
          <p
            :class="bem('card-sub-title')"
          >
            Built to order same-day and covered by our Lifetime Guarantee.
          </p>
        </div>
      </SwiperSlide>

      <SwiperSlide
        v-if="
          customisedProduct.conversionKitEnabled
            && customisedProduct.secondarySKU
            && showDefaultInTheBoxProduct
        "
        :class="bem('slide')"
      >
        <div :class="bem('img-container')">
          <DynamicImg
            :view-angle="2"
            bg=""
            :width="400"
            :height="200"
            :sku="customisedProduct.secondaryLegacySKU"
            :scale="1.1"
          />
        </div>
        <div :class="bem('card-content')">
        <h5 :class="bem('card-title')">SunGod {{ customisedProduct.secondaryName }}</h5>
        <p
          :class="bem('card-sub-title')"
        >
          Built to order same-day and covered by our Lifetime Guarantee.'
        </p>
        </div>
      </SwiperSlide>

      <SwiperSlide
        v-for="slide in items"
        :key="slide.title"
        :class="bem('slide')"
      >
        <div :class="bem('img-container')">
          <img
            :src="slide.img"
            :alt="slide.title"
          />
        </div>
        <div :class="bem('card-content')">
          <h5 :class="bem('card-title')">{{ slide.title }}</h5>
          <p
            :class="bem('card-sub-title')"
          >
            {{ slide.description }}
          </p>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'

const bem = useBEM('InTheBoxCarousel')

const props = defineProps({
  customisedProduct: {
    type: Object,
    default: () => {}
  },
  layerTemplate: { type: Object, default: () => ({}) },
  show360: { type: Boolean, required: true },
  showIrisPreview: { type: Boolean, required: true },
})

const pdpConfig = computed(() => {
  return props.customisedProduct.product.pdpConfigWithDefaults
})

const showDefaultInTheBoxProduct = computed(() => {
  return pdpConfig.value.showDefaultInTheBoxProduct
})

const items = computed(() => {
  return pdpConfig.value.inTheBoxItems
    .filter((item) => item.title !== 'SunGod Sticker Pack')
    .map((item) => ({
      img: item.image.url,
      ...item,
    }))
})

const intheboxSwiperOptions = computed(() => {
  return {
    slidesPerView: 2,
    grabCursor: true,
    spaceBetween: 16,
    breakpoints: {
      400: {
        slidesPerView: 2,
      },
    },
  }
})
</script>

<style lang="postcss" scoped>
.InTheBoxCarousel {
  @apply w-full;
}

.InTheBoxCarousel__slide {
  @apply bg-grey-200 border border-grey-400 rounded-md h-auto;
}

.InTheBoxCarousel__img-container {
  @apply aspect-square flex items-center justify-center mx-2 mt-2 rounded-sm overflow-hidden relative;
}

.InTheBoxCarousel__product-img {
  @apply w-full aspect-square;
}

.InTheBoxCarousel__card-content {
  @apply px-2 py-4 sm:p-4;
}

.InTheBoxCarousel__card-title {
  @apply heading-6 mb-1 text-balance;
}

.InTheBoxCarousel__card-sub-title {
  @apply text-xxs sm:text-xs;
}
</style>